---
fr:
  dashboard:
    gwh_ytd: GWh YTD
    m_currency_ytd: M%{currency} YTD
    mm_48h: 48h
    of_ytd_average: de la moyenne YTD
    plants_in_operation: Installations en service
    total_volume: Total production
    volume_for_asset_type: production {type}
